import type { Dispatch, ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

type Id = number | string;

interface DataTableState {
	selected: Id[];
	setSelected: Dispatch<React.SetStateAction<Id[]>>;
}

const DataTableContext = createContext<DataTableState | null>({
	selected: [],
	setSelected: () => undefined,
});

// Context used for data shared across all data table pages
export const useDataTableMeta = (): DataTableState => {
	const context = useContext(DataTableContext);
	if (context === null) {
		throw new Error(
			'Could not get data table context. Did you forget to use DataTableProvider?'
		);
	}

	return context;
};

interface DataTableMetaProviderProps {
	key: string;
	children: ReactNode;
}

export function DataTableMetaProvider({
	children,
}: DataTableMetaProviderProps) {
	const [selectedState, setSelectedState] = useState<Id[]>([]);

	const value: DataTableState = {
		selected: selectedState,
		setSelected: setSelectedState,
	};

	return (
		<DataTableContext.Provider value={value}>
			{children}
		</DataTableContext.Provider>
	);
}
